export const volumes = [
  {
    number: 1,
    title: 'Basiskracht & stabiliteit',
    tagline: 'Bouw een sterkere basis',
    sessions: '61 sessies',
    months: 'Maanden 1–2',
    desc: 'Leg vanaf dag één een stevig fundament en structurele kracht bij je deelnemers.',
    bar: 'bg-orange-500',
    text: 'text-orange-400',
    border: 'border-t-orange-500',
  },
  {
    number: 2,
    title: 'Explosieve kracht & functionele transfer',
    tagline: 'Zet kracht om in power',
    sessions: '61 sessies',
    months: 'Maanden 3–4',
    desc: 'Ontwikkel snelheid, explosiviteit en directe transfer naar echte atletische bewegingen.',
    bar: 'bg-blue-500',
    text: 'text-blue-400',
    border: 'border-t-blue-500',
  },
  {
    number: 3,
    title: 'Metabole conditie & vetverlies',
    tagline: 'Meer uithoudingsvermogen. Meer verbranding.',
    sessions: '61 sessies',
    months: 'Maanden 5–6',
    desc: 'Verbrand vet en til de metabole conditie van je groep naar het maximum.',
    bar: 'bg-green-500',
    text: 'text-green-400',
    border: 'border-t-green-500',
  },
  {
    number: 4,
    title: 'Functionele hypertrofie',
    tagline: 'Meer spiermassa. Meer functie.',
    sessions: '61 sessies',
    months: 'Maanden 7–8',
    desc: 'Bouw functioneel spiermassa op met hypertrofieprotocollen die zijn aangepast voor groepstraining.',
    bar: 'bg-red-500',
    text: 'text-red-400',
    border: 'border-t-red-500',
  },
  {
    number: 5,
    title: 'Wendbaarheid & atletisch prestatievermogen',
    tagline: 'Sneller bewegen. Verder komen.',
    sessions: '61 sessies',
    months: 'Maanden 9–10',
    desc: 'Verbeter coördinatie, wendbaarheid en algemeen atletisch vermogen op elk niveau.',
    bar: 'bg-yellow-400',
    text: 'text-yellow-300',
    border: 'border-t-yellow-400',
  },
  {
    number: 6,
    title: 'Specialisatie & einduitdagingen',
    tagline: 'Integreren. Presteren. Afronden.',
    sessions: '60 sessies',
    months: 'Maanden 11–12',
    desc: 'Zet het hele jaar op de proef met uitdagingen en competitieve benchmarks.',
    bar: 'bg-purple-500',
    text: 'text-purple-400',
    border: 'border-t-purple-500',
  },
]

export const sessionFeatures = [
  { title: 'Dagdoel', desc: 'Zodat je precies weet waar je naartoe werkt' },
  { title: 'Kant-en-klare warming-up', desc: 'Nooit meer geïmproviseerde warming-ups' },
  { title: '3 versies: A/B/C', desc: 'Gemengde groep of aparte groepen — het werkt altijd' },
  { title: 'Sets, herhalingen & timing', desc: 'Volledig uitgeschreven — niets vaags' },
  { title: 'Professionele cool-down', desc: 'Sluit elke les gestructureerd af' },
  { title: 'Tip van de coach', desc: 'Nieuw als coach? Dan leer je. Al een pro? Dan bevestig je.' },
  { title: 'Eén sessie per pagina', desc: 'Openen, lesgeven, klaar' },
]

export const featureChips = [
  'Gym + Boksen + Functioneel',
  'Programma voor een heel jaar',
  'A/B/C-versies per niveau',
  'Warm-ups & cool-downs',
  '365 kant-en-klare sessies',
  'Alleen basismateriaal',
]
